module.exports = __webpack_public_path__ + "static/la-ventures-barclays-8665865a5340181e121a1ce3e7ac345a.jpg";